<template>
  <div id="app">


      <div class="main">
        <div class="cup" :style="cupBackground">

          <img src="static/eye-dropper.png" alt="" width="400" height="400" class="catalyst" :class="showDrop == true ? 'show' : ''">

          <svg width="400" height="400" viewBox="0 0 400 400" class="dots">
            <g id="dots">

              <template v-for="dot in dots">
                <dot :cx="dot.cx" :cy="dot.cy" :r="dot.r" :fill="dot.fill" :opacity="!isNaN(dot.opacity) ? dot.opacity : 0.6" />
              </template>

            </g>
          </svg>
          <div class="label"><span class="a">A</span> + <span class="b">B</span> &xrarr; <span class="c">C</span></div>
        </div>
        <div class="content">

          <transition-group name="fade">

            <div class="intro" key="intro" v-show="startedSim == false">
              <h1>Reaction Rates</h1>
              <p>Examine a chemical reaction and then investigate variables that can affect its rate.</p>
              <button class="btn" v-on:click="runControlReaction">Run Reaction</button>
            </div>

            <div class="simstart" key="simstart" v-show="startedSim == 'kinda'">
              <svg width="300" height="300" viewBox="0 0 300 300" class="graph">
                <g id="ctrlGraph">
                  <g id="ctrlLabelsnlines">
                    <text x="-200" y="10" font-family="proxima-nova" font-size="13" fill="#797d82" style="transform:rotate(-90deg)">Amount of Product</text>
                    <text x="140" y="300" font-family="proxima-nova" font-size="13" fill="#797d82">Time</text>
                    <line x1="25" y1="275" x2="275" y2="275" stroke="#797d82" />
                    <line x1="25" y1="25" x2="25" y2="275" stroke="#797d82" />
                    <circle cx="278" cy="32" r="21" stroke="#ccc" stroke-width="1.8" fill="#ffffff" class="clock" />
                    <line x1="274.06" y1="3.84" x2="280.66" y2="3.84" style="fill: none;stroke: #ccc;stroke-linecap: round;stroke-linejoin: round;stroke-width: 5px"/>
                    <path d="M280.25,26.25c.07,2.59-1.2,4.72-2.85,4.77s-3-2-3.11-4.6S277,15.19,277,15.19,280.18,23.66,280.25,26.25Z" style="fill: #797d83" class="hand" :class="startSpinning" />
                  </g>
                  <g id="ctrlGraphdata">
                    <line x1="25" y1="275" :x2="ctrlGoing.x" :y2="ctrlGoing.y" stroke="#CC00F0" />
                  </g>
                </g>
              </svg>
              <button class="btn" v-on:click="mixItUp">Select Variables &rarr;</button>
            </div>

            <div class="sim" key="sim" v-show="startedSim == true">
              <h1>Variables</h1>

              <v-exselect class="variables" v-model="reactionVariable" :options="['Catalyst','Concentration','Surface Area','Temperature','Control']" :searchable="false"></v-exselect>


              <div class="buttons" :class="showButtons == true ? 'show' : ''">
                <button :disabled="step === 2" class="btn grey" :class="increaseOrDecrease == 'decrease' ? 'dark' : ''" v-on:click="decrease">Decrease</button>
                <button :disabled="step === 2" class="btn grey" :class="increaseOrDecrease == 'increase' ? 'dark' : ''" v-on:click="increase">Increase</button>
              </div>

              <svg width="300" height="300" viewBox="0 0 300 300" class="graph">
                <g id="graph">
                  <g id="labelsnlines">
                    <text x="-200" y="10" font-family="proxima-nova" font-size="13" fill="#797d82" style="transform:rotate(-90deg)">Amount of Product</text>
                    <text x="140" y="300" font-family="proxima-nova" font-size="13" fill="#797d82">Time</text>
                    <line x1="25" y1="275" x2="275" y2="275" stroke="#797d82" />
                    <line x1="25" y1="25" x2="25" y2="275" stroke="#797d82" />
                    <circle cx="278" cy="32" r="21" stroke="#ccc" stroke-width="1.8" fill="#ffffff" class="clock" />
                    <line x1="274.06" y1="3.84" x2="280.66" y2="3.84" style="fill: none;stroke: #ccc;stroke-linecap: round;stroke-linejoin: round;stroke-width: 5px"/>
                    <path d="M280.25,26.25c.07,2.59-1.2,4.72-2.85,4.77s-3-2-3.11-4.6S277,15.19,277,15.19,280.18,23.66,280.25,26.25Z" style="fill: #797d83" class="hand" :class="startSpinning" />
                  </g>
                  <g id="graphdata">
                    <line x1="25" y1="275" :x2="going.x" :y2="going.y" stroke="#CC00F0" />
                    <line x1="25" y1="275" :x2="varGoing.x" :y2="varGoing.y" stroke="#CC00F0" stroke-width="2" stroke-dasharray="4, 8" stroke-linecap="round" />
                    <!--line x1="25" y1="275" x2="245" y2="45" stroke="#CC00F0" />
                    <line x1="25" y1="275" x2="140" y2="45" stroke="#CC00F0" stroke-width="2" stroke-dasharray="4, 8" stroke-linecap="round" />
                    <line x1="25" y1="275" x2="245" y2="165" stroke="#CC00F0" stroke-width="2" stroke-dasharray="4, 8" stroke-linecap="round" /-->
                  </g>
                </g>
              </svg>

              <button class="btn" :class="canRunReaction == false ? 'disabled' : ''" :disabled="canRunReaction == false" v-on:click="runReaction"><span v-html="runReactionLabel"></span></button>
            </div>

          </transition-group>

        </div>
      </div>


  </div>
</template>

<script>
import dot from './components/dot'
import vExselect from './components/ExtendedVueSelect'
var TWEEN = require('@tweenjs/tween.js')
var BezierEasing = require('bezier-easing')
export default {
  name: 'app',
  components: {
    dot,
    vExselect
  },
  data: function () {
    return {
      startedSim: false,
      reactionVariable: 'Control',
      runReactionLabel: 'Run Reaction',
      cupBackground: 'background-image: url(static/beaker-default.png)',
      increaseOrDecrease: null,
      step: 1,
      // "going" vars, for the line graphs
      ctrlGoing: { x: 25, y: 275 },
      going: { x: 25, y: 275 },
      varGoing: { x: 25, y: 275 },
      // default start and end positions of the line
      // plus the end positions for faster/slower reactions
      startGo: { x: 25, y: 275 },
      end: { x: 245, y: 45 },
      fastEnd: { x: 165, y: 45 },
      slowEnd: { x: 245, y: 165 },
      reactionTime: 5000,
      startSpinning: false,
      dots: []
    }
  },
  created: function () {
    this.defaultDots()
  },
  computed: {
    showButtons: function () {
      if (this.reactionVariable === 'Control' || this.reactionVariable === 'Catalyst' || this.reactionVariable === null) {
        return false
      } else {
        return true
      }
    },
    showDrop: function () {
      if (this.reactionVariable === 'Catalyst') {
        return true
      } else {
        return false
      }
    },
    canRunReaction: function () {
      if (this.reactionVariable === 'Catalyst' || this.reactionVariable === 'Control') {
        return true
      } else {
        if (this.increaseOrDecrease !== null) {
          return true
        } else {
          return false
        }
      }
    }
  },
  watch: {
    reactionVariable: function (newV, oldV) {
      if (newV !== oldV) {
        this.resetReaction()
      }
    },
    going: function (newV, oldV) {
      function animate () {
        if (TWEEN.update()) {
          requestAnimationFrame(animate)
        }
      }
      if (this.step === 2) {
        new TWEEN.Tween(this.going)
          .to(this.end, 5000)
          .start()

        animate()
      }
    },
    ctrlGoing: function () {
      function animate () {
        if (TWEEN.update()) {
          requestAnimationFrame(animate)
        }
      }

      new TWEEN.Tween(this.ctrlGoing)
        .to(this.end, 5000)
        .start()

      animate()
    },
    varGoing: function () {
      function animate () {
        if (TWEEN.update()) {
          requestAnimationFrame(animate)
        }
      }
      if (this.step === 2) {
        var whichEnd
        if (this.increaseOrDecrease === 'increase') { whichEnd = this.fastEnd } else { whichEnd = this.slowEnd }

        var rv = this.reactionVariable
        if (rv === 'Catalyst') { whichEnd = this.fastEnd } else if (rv === 'Control') { whichEnd = this.varGoing }

        new TWEEN.Tween(this.varGoing)
          .to(whichEnd, this.reactionTime)
          .start()

        animate()
      }
    }
  },
  methods: {
    runControlReaction: function () {
      this.ctrlGoing = { x: this.startGo.x, y: this.startGo.y }
      this.startedSim = 'kinda'
      this.startSpinning = 'spin'

      this.defaultDotsRun()
    },
    defaultDots: function () {
      this.cupBackground = 'background-image: url(static/beaker-default.png)'
      this.dots = [
        { cx: 260, cy: 200, r: 10, fill: '#E01100' },
        { cx: 260, cy: 230, r: 10, fill: '#E01100' },
        { cx: 260, cy: 260, r: 10, fill: '#E01100' },
        { cx: 260, cy: 290, r: 10, fill: '#E01100' },
        { cx: 260, cy: 320, r: 10, fill: '#E01100' },
        { cx: 160, cy: 200, r: 10, fill: '#0031DF' },
        { cx: 160, cy: 230, r: 10, fill: '#0031DF' },
        { cx: 160, cy: 260, r: 10, fill: '#0031DF' },
        { cx: 160, cy: 290, r: 10, fill: '#0031DF' },
        { cx: 160, cy: 320, r: 10, fill: '#0031DF' }
      ]
    },
    increaseConcentrationDots: function () {
      this.cupBackground = 'background-image: url(static/beaker-default.png)'
      this.dots = [
        { cx: 230, cy: 200, r: 10, fill: '#E01100' },
        { cx: 230, cy: 230, r: 10, fill: '#E01100' },
        { cx: 230, cy: 260, r: 10, fill: '#E01100' },
        { cx: 230, cy: 290, r: 10, fill: '#E01100' },
        { cx: 230, cy: 320, r: 10, fill: '#E01100' },
        { cx: 270, cy: 200, r: 10, fill: '#E01100' },
        { cx: 270, cy: 230, r: 10, fill: '#E01100' },
        { cx: 270, cy: 260, r: 10, fill: '#E01100' },
        { cx: 270, cy: 290, r: 10, fill: '#E01100' },
        { cx: 270, cy: 320, r: 10, fill: '#E01100' },
        { cx: 150, cy: 200, r: 10, fill: '#0031DF' },
        { cx: 150, cy: 230, r: 10, fill: '#0031DF' },
        { cx: 150, cy: 260, r: 10, fill: '#0031DF' },
        { cx: 150, cy: 290, r: 10, fill: '#0031DF' },
        { cx: 150, cy: 320, r: 10, fill: '#0031DF' },
        { cx: 190, cy: 200, r: 10, fill: '#0031DF' },
        { cx: 190, cy: 230, r: 10, fill: '#0031DF' },
        { cx: 190, cy: 260, r: 10, fill: '#0031DF' },
        { cx: 190, cy: 290, r: 10, fill: '#0031DF' },
        { cx: 190, cy: 320, r: 10, fill: '#0031DF' }
      ]
    },
    decreaseConcentrationDots: function () {
      this.cupBackground = 'background-image: url(static/beaker-default.png)'
      this.dots = [
        { cx: 240, cy: 220, r: 10, fill: '#E01100' },
        { cx: 240, cy: 260, r: 10, fill: '#E01100' },
        { cx: 240, cy: 300, r: 10, fill: '#E01100' },
        { cx: 180, cy: 220, r: 10, fill: '#0031DF' },
        { cx: 180, cy: 260, r: 10, fill: '#0031DF' },
        { cx: 180, cy: 300, r: 10, fill: '#0031DF' }
      ]
    },
    increaseSurfaceAreaDots: function () {
      this.cupBackground = 'background-image: url(static/beaker-high-sa.png)'
      this.dots = [
        { cx: 265, cy: 150, r: 10, fill: '#E01100' },
        { cx: 265, cy: 195, r: 10, fill: '#E01100' },
        { cx: 265, cy: 240, r: 10, fill: '#E01100' },
        { cx: 265, cy: 285, r: 10, fill: '#E01100' },
        { cx: 265, cy: 330, r: 10, fill: '#E01100' },
        { cx: 155, cy: 150, r: 10, fill: '#0031DF' },
        { cx: 155, cy: 195, r: 10, fill: '#0031DF' },
        { cx: 155, cy: 240, r: 10, fill: '#0031DF' },
        { cx: 155, cy: 285, r: 10, fill: '#0031DF' },
        { cx: 155, cy: 330, r: 10, fill: '#0031DF' }
      ]
    },
    decreaseSurfaceAreaDots: function () {
      this.cupBackground = 'background-image: url(static/beaker-high-sa.png)'
      this.dots = [
        { cx: 240, cy: 328, r: 10, fill: '#E01100' },
        { cx: 226, cy: 300, r: 10, fill: '#E01100' },
        { cx: 200, cy: 296, r: 10, fill: '#E01100' },
        { cx: 176, cy: 303, r: 10, fill: '#E01100' },
        { cx: 185, cy: 330, r: 10, fill: '#E01100' },
        { cx: 210, cy: 320, r: 10, fill: '#0031DF' },
        { cx: 160, cy: 281, r: 10, fill: '#0031DF' },
        { cx: 142, cy: 299, r: 10, fill: '#0031DF' },
        { cx: 159, cy: 322, r: 10, fill: '#0031DF' },
        { cx: 138, cy: 330, r: 10, fill: '#0031DF' }
      ]
    },
    generatePositionsArray: function (maxX, maxY, safeRadius, irregularity) {
      var positionsArray = []
      var r
      var c
      var rows
      var columns
      // count the amount of rows and columns
      rows = Math.floor(maxY / safeRadius)
      columns = Math.floor(maxX / safeRadius)
      // loop through rows
      for (r = 1; r <= rows; r += 1) {
        // loop through columns
        for (c = 1; c <= columns; c += 1) {
          // populate array with point object
          positionsArray.push({
            x: Math.round(maxX * c / columns) + this.getRandomInt(irregularity * -1, irregularity),
            y: Math.round(maxY * r / rows) + this.getRandomInt(irregularity * -2, irregularity * 2)
          })
        }
      }
      // return array
      return positionsArray
    },
    getRandomPosition: function (array, removeTaken) {
      var randomIndex
      var coordinates
      // get random index
      randomIndex = this.getRandomInt(0, array.length - 1)
      // get random item from array
      coordinates = array[randomIndex]
      // check if remove taken
      if (removeTaken) {
        // remove element from array
        array.splice(randomIndex, 1)
      }
      // return position
      return coordinates
    },
    getRandomInt: function (min, max) {
      return Math.floor(Math.random() * (max - min)) + min
    },
    getRandomNFromArr: function (arr, n) {
      n = Math.ceil(n)
      var result = new Array(n)
      var len = arr.length
      var taken = new Array(len)
      if (n > len) { return arr }
      while (n--) {
        var x = Math.floor(Math.random() * len)
        result[n] = arr[x in taken ? taken[x] : x]
        taken[x] = --len in taken ? taken[len] : len
      }
      return result
    },
    map: function (num, inMin, inMax, outMin, outMax) {
      var r = (num - inMin) * (outMax - outMin) / (inMax - inMin) + outMin
      if (isNaN(r)) { return outMax }
      return r
    },
    defaultDotsRun: function () {
      // set new random x/y within the bounds for the dots to move to
      var that = this
      var thedots = this.dots
      var posYOff = this.reactionVariable === 'Surface Area' ? 140 : 190
      var safeSpace = 25
      if (this.reactionVariable === 'Concentration') { safeSpace = 20 }
      var positions = this.generatePositionsArray(120, 310 - posYOff, safeSpace, 3)
      if (positions.length <= thedots.length) {
        var morePositions = this.generatePositionsArray(120, 310 - posYOff, safeSpace, 3)
        positions = positions.concat(morePositions)
      }

      thedots.forEach(function (dot, index) {
        dot.origcx = dot.cx
        dot.origcy = dot.cy
        var pos
        var posYOff = that.reactionVariable === 'Surface Area' ? 140 : 190
        if (index < (thedots.length / 2)) {
          dot.newfill = '#622170'
          pos = that.getRandomPosition(positions, true)
          dot.newcx = pos.x + 150
          dot.newcy = pos.y + posYOff
        } else {
          dot.newfill = '#622170'
          pos = that.getRandomPosition(positions, true)
          dot.newcx = pos.x + 150
          dot.newcy = pos.y + posYOff
          // dot.newcx = thedots[index - (thedots.length / 2)].newcx
          // dot.newcy = thedots[index - (thedots.length / 2)].newcy
        }
      })

      // get random half to fade
      // iterators are weird
      var thedotsindexes = [...thedots.keys()]
      var halfdots = this.getRandomNFromArr(thedotsindexes, (thedots.length / 2))

      // loop through the dots one more time and animate them from old xy to new xy and wiggle x
      thedots.forEach(function (dot, index) {
        function animate (time) {
          requestAnimationFrame(animate)
          TWEEN.update(time)
        }
        requestAnimationFrame(animate)

        var coords = { x: dot.origcx, y: dot.origcy }
        var steps = (that.reactionTime / (thedots.length / 2)) // time between steps
        steps = steps / that.reactionTime // steps are this out of 1

        new TWEEN.Tween(coords)
          .to({ x: dot.newcx, y: dot.newcy }, that.reactionTime)
          .easing(that.createWigglyEasing())
          .onUpdate(function () {
            var xw = that.map(coords.x, dot.origcx, dot.newcx, 0, thedots.length)
            var yw = that.map(coords.y, dot.origcy, dot.newcy, 0, thedots.length)
            var xwig = Math.sin(xw) * (that.reactionTime / 1000)
            var ywig = Math.sin(yw) * (that.reactionTime / 2000)
            dot.cx = coords.x + xwig
            dot.cy = coords.y + ywig
            if (halfdots.includes(index)) {
              var hindex = halfdots.indexOf(index) + 1
              if (thedots.length < 10) { xw = xw * 2 }
              if ((hindex * steps) * 10 < xw) {
                dot.fill = dot.newfill
              }
            } else {
              dot.opacity = (1 - (xw * (1 / thedots.length))) * 0.6
              dot.xo = dot.opacity
            }
          })
          .onComplete(function () {
            dot.opacity = dot.xo
          })
          .start()
      })
    },
    decreasedDotsRun: function () {
      // set new random x/y within the bounds for the dots to move to
      var that = this
      var thedots = this.dots
      var posYOff = this.reactionVariable === 'Surface Area' ? 140 : 190
      var safeSpace = 25
      var positions = this.generatePositionsArray(120, 310 - posYOff, safeSpace, 3)
      if (positions.length <= thedots.length) {
        var morePositions = this.generatePositionsArray(120, 310 - posYOff, safeSpace, 3)
        positions = positions.concat(morePositions)
      }

      thedots.forEach(function (dot, index) {
        dot.origcx = dot.cx
        dot.origcy = dot.cy
        var pos
        var posYOff = that.reactionVariable === 'Surface Area' ? 140 : 190
        if (index < (thedots.length / 2)) {
          dot.newfill = '#622170'
          pos = that.getRandomPosition(positions, true)
          dot.newcx = pos.x + 150
          dot.newcy = pos.y + posYOff
        } else {
          dot.newfill = '#622170'
          pos = that.getRandomPosition(positions, true)
          dot.newcx = pos.x + 150
          dot.newcy = pos.y + posYOff
          // dot.newcx = thedots[index - (thedots.length / 2)].newcx
          // dot.newcy = thedots[index - (thedots.length / 2)].newcy
        }
      })

      // get random half to fade
      // iterators are weird
      // var thedotsindexes = [...thedots.keys()]
      // hard code these instead!
      var halfdots = [0, 1, 2, 3, 5, 6, 7, 8]
      var halfhalf = [0, 5]

      // loop through the dots one more time and animate them from old xy to new xy and wiggle x
      thedots.forEach(function (dot, index) {
        function animate (time) {
          requestAnimationFrame(animate)
          TWEEN.update(time)
        }
        requestAnimationFrame(animate)

        var coords = { x: dot.origcx, y: dot.origcy }
        var steps = (that.reactionTime / (thedots.length / 2)) // time between steps
        steps = steps / that.reactionTime // steps are this out of 1

        new TWEEN.Tween(coords)
          .to({ x: dot.newcx, y: dot.newcy }, that.reactionTime)
          .easing(that.createWigglyEasing())
          .onUpdate(function () {
            var xw = that.map(coords.x, dot.origcx, dot.newcx, 0, thedots.length)
            var yw = that.map(coords.y, dot.origcy, dot.newcy, 0, thedots.length)
            var xwig = Math.sin(xw) * (that.reactionTime / 1000)
            var ywig = Math.sin(yw) * (that.reactionTime / 2000)
            dot.cx = coords.x + xwig
            dot.cy = coords.y + ywig
            if (halfdots.includes(index)) {
              var hindex = halfdots.indexOf(index) + 1
              if ((hindex * steps) * 10 < xw) {
                if (halfhalf.includes(halfdots[hindex - 1])) {
                  dot.fill = dot.newfill
                }
              }
            } else {
              dot.opacity = (1 - (xw * 0.1)) * 0.6
              dot.xo = dot.opacity
            }
          })
          .onComplete(function () {
            dot.opacity = dot.xo
          })
          .start()
      })
    },
    createNoisyEasing: function (randomProportion, easingFunction) {
      var normalProportion = 1.0 - randomProportion
      return function (k) {
        return randomProportion * Math.random() + normalProportion * easingFunction(k)
      }
    },
    createWigglyEasing: function () {
      var ease = BezierEasing(0.68, 0.76, 0.71, 1.1)
      return function (k) {
        return ease(k)
      }
    },
    mixItUp: function () {
      this.startedSim = true
      this.startSpinning = false
      this.defaultDots()
    },
    runReaction: function () {
      if (this.step === 1) {
        this.runReactionLabel = 'Start Over &rarr;'
        this.step++

        this.startSpinning = 'spin'
        var rv = this.reactionVariable

        if (this.increaseOrDecrease === 'increase') {
          this.reactionTime = 2500
        }

        if (rv === 'Catalyst') {
          this.reactionTime = 2500
          this.defaultDotsRun()
        } else if (rv === 'Concentration') {
          this.defaultDotsRun()
        } else if (rv === 'Surface Area') {
          if (this.increaseOrDecrease === 'increase') {
            this.defaultDotsRun()
          } else if (this.increaseOrDecrease === 'decrease') {
            this.decreasedDotsRun()
          }
        } else if (rv === 'Temperature') {
          if (this.increaseOrDecrease === 'increase') {
            this.defaultDotsRun()
          } else if (this.increaseOrDecrease === 'decrease') {
            this.decreasedDotsRun()
          }
        } else if (rv === 'Control') {
          this.defaultDotsRun()
          this.going = { x: this.startGo.x, y: this.startGo.y }
        }
        this.varGoing = { x: this.startGo.x, y: this.startGo.y }
      } else if (this.step === 2) {
        this.resetReaction()
      }
    },
    resetReaction: function (iOrD = null) {
      this.step = 1
      this.runReactionLabel = 'Run Reaction'
      this.increaseOrDecrease = iOrD
      this.startSpinning = false
      this.reactionTime = 5000

      var rv = this.reactionVariable
      if (rv === 'Catalyst') {
        this.defaultDots()
        this.going = { x: this.end.x, y: this.end.y }
      } else if (rv === 'Concentration') {
        this.defaultDots()
        this.going = { x: this.end.x, y: this.end.y }
        if (this.increaseOrDecrease === 'increase') {
          this.increaseConcentrationDots()
        } else if (this.increaseOrDecrease === 'decrease') {
          this.decreaseConcentrationDots()
        }
      } else if (rv === 'Surface Area') {
        this.defaultDots()
        this.going = { x: this.end.x, y: this.end.y }
        this.cupBackground = 'background-image: url(static/beaker-high-sa.png)'
        if (this.increaseOrDecrease === 'increase') {
          this.increaseSurfaceAreaDots()
        } else if (this.increaseOrDecrease === 'decrease') {
          this.decreaseSurfaceAreaDots()
        }
      } else if (rv === 'Temperature') {
        this.defaultDots()
        this.going = { x: this.end.x, y: this.end.y }
      } else if (rv === 'Control') {
        this.defaultDots()
        this.going = { x: this.startGo.x - 1, y: this.startGo.y + 1 }
      }
      this.varGoing = { x: this.startGo.x - 1, y: this.startGo.y + 1 }
    },
    increase: function () {
      if (this.increaseOrDecrease === 'increase') {
        this.increaseOrDecrease = null
      } else {
        this.increaseOrDecrease = 'increase'
      }
      this.resetReaction(this.increaseOrDecrease)
    },
    decrease: function () {
      if (this.increaseOrDecrease === 'decrease') {
        this.increaseOrDecrease = null
      } else {
        this.increaseOrDecrease = 'decrease'
      }
      this.resetReaction(this.increaseOrDecrease)
    }
  }
}
</script>

<style lang="scss">
@import "assets/styles.scss";
.main {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  min-height: 600px;
  h1 {
    font: bold 32px $font-family;
    color: $dk_grey;
    margin: 0 0 16px;
    letter-spacing: 1.5px;
  }
  p br { display: none; }
  .content {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-left: 3em;
    overflow: hidden;
   }
  .cup {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;
    width: 45%;
    height: 100%;
    background: #eee no-repeat center center / 120% auto;
  }
}

img.catalyst {
  position: absolute;
  transform: translateY(-110%);
  width: 90%;
  height: auto;
  margin: auto;
  opacity: 0;
  transition: all 0.2s;
  &.show { 
    opacity: 1; 
    transform: translateY(-85%);
  }
}
svg {
  max-width: 100%;
  height: auto;
}

div.label {
  position: absolute;
  width: 100%;
  height: 25%;
  padding-top: 50%;
  padding-left: 5px;
  text-align: center;
  font-size: 20px;
  opacity: 0.7;
  span { font-weight: bold; }
  span.a { color: #0031DF; }
  span.b { color: #E01100; }
  span.c { color: #722180; }
}

.v-select .dropdown-toggle { 
  white-space: nowrap !important; 
  overflow: hidden; 
}
button.clear { display: none; }
.v-select .open-indicator { 
  &:before { border-color: #000; }
}
.v-select .selected-tag { position: absolute; }

.variables {
  background: $lt_grey;
  border-color: $lt_grey;
  color: #000;
  text-transform: uppercase;
  font: bold 16px $font-family !important;
  letter-spacing: 2px;
  cursor: pointer;
  margin-bottom: 16px;
  width: 240px;
}
ul.dropdown-menu {
  font: normal 16px $font-family !important; 
  text-transform: uppercase !important; 
  background: $lt_grey !important;
  padding: 0 !important;
  li { 
    background: $lt_grey; 
    padding: 0 !important;
  }
}
.clock {
  fill: #fff;
}
.hand {
  transform-origin: 92.5% 10.6%;
  &.spin { animation: spin 5s linear; }
}

.buttons {
  opacity: 0;
  pointer-events: none;
  transition: all 0.2s;
  &.show { 
    opacity: 1; 
    pointer-events: auto;
  }
}

.graph {
  margin: 20px 0 20px -20px;
}

.fade-enter-active, .fade-leave-active {
  transition: all 0.25s ease;
}
.fade-enter-active {
  transition-delay: 0.35s;
}
.fade-enter, .fade-leave-active {
  opacity: 0.15;
}
.btn {
  border: none;
  background: $blue;
  color: #fff;
  padding: 10px 40px;
  text-transform: uppercase;
  font: bold 16px $font-family;
  letter-spacing: 2px;
  cursor: pointer;
  &.grey { 
    background: $lt_grey; 
    font-size: 15px;
    letter-spacing: 1px;
    padding: 10px 30px;
  }
  &.dark { background: $dk_grey; }
  &.disabled, &[disabled] {
    opacity: 0.35;
    pointer-events: none;
  }
}
p { 
  color: $dk_grey;
  font-size: 20px;
  letter-spacing: 1.5px;
  margin: 0 0 20px;
}
@keyframes spin {
    from {transform:rotate(0deg);}
    to {transform:rotate(360deg);}
}
</style>


// WEBPACK FOOTER //
// App.vue?2989061a